/* eslint-disable import/prefer-default-export */
import type * as Actions from '@src/redux/actions/dashboard.actions'
import * as ActionTypes from '@src/redux/actionTypes'
import { getGraph } from '@src/utils/redux.tools'
import { defaultState } from './default.state'
import { isEmpty } from 'lodash'

export function searchReducer(
  state = defaultState,
  action: Actions.ActionTypes
) {
  switch (action.type) {
    case ActionTypes.Dashboard.SEARCH_USAGE_RESULTS_SUCCESS:
    case ActionTypes.Dashboard.SEARCH_PRIVILEGE_RESULTS_SUCCESS:
    case ActionTypes.Dashboard.SEARCH_CROSS_ACCOUNT_RESULTS_SUCCESS: {
      const { table } = action.payload
      return {
        ...state,
        table
      }
    }
    case ActionTypes.Dashboard.SEARCH_RESULTS_SUCCESS: {
      const {
        graph,
        table,
        objects,
        identities,
        policies,
        autoCompleteRespType,
        sqlQueryUserUsage
      } = action.payload
      return {
        ...state,
        ...getGraph({ state, graph }),
        table,
        objectsList: objects,
        identitiesList: identities,
        policiesList: policies,
        autoCompleteRespType:
          autoCompleteRespType || defaultState.autoCompleteRespType,
        sqlQueryUserUsage: sqlQueryUserUsage || defaultState.sqlQueryUserUsage
      }
    }
    default:
      return state
  }
}

export function reducer(state = defaultState, action: Actions.ActionTypes) {
  switch (action.type) {
    case ActionTypes.Dashboard.GET_STAT_SUCCESS: {
      return {
        ...state,
        [action.payload.stat]: action.payload.value,
        isPending: false
      }
    }

    case ActionTypes.Dashboard.CLEANER_STAT: {
      if (!isEmpty(action.payload.stat))
        return {
          ...state,
          [action.payload.stat]: defaultState[action.payload.stat]
        }
      return state
    }

    case ActionTypes.Dashboard.SEARCH_USAGE_RESULTS_SUCCESS:
    case ActionTypes.Dashboard.SEARCH_PRIVILEGE_RESULTS_SUCCESS:
    case ActionTypes.Dashboard.SEARCH_CROSS_ACCOUNT_RESULTS_SUCCESS:
    case ActionTypes.Dashboard.SEARCH_RESULTS_SUCCESS: {
      return searchReducer(state, action)
    }

    case ActionTypes.Dashboard.REFRESH_CALENDAR_SUCCESS: {
      return {
        ...state
      }
    }

    case ActionTypes.Dashboard.REFRESH_CALENDAR_FAIL: {
      return {
        ...state,
        error: action.payload.error
      }
    }

    case ActionTypes.Dashboard.SERVER_ERRORS: {
      return {
        ...state,
        errors: action.payload.errors
      }
    }

    case ActionTypes.Dashboard.REQUEST_PENDING: {
      return {
        ...state,
        isPending: action.payload.isPending
      }
    }
    case ActionTypes.Dashboard.REQUEST_PENDING_GRAPH: {
      return {
        ...state,
        graph: action.payload.isPending ? {} : state.graph,
        isPendingGraph: action.payload.isPending
      }
    }

    case ActionTypes.Dashboard.GET_SEV_COUNTS: {
      return {
        ...state,
        highCount: action.payload.sevCounts.high_count,
        mediumCount: action.payload.sevCounts.medium_count,
        lowCount: action.payload.sevCounts.low_count
      }
    }

    case ActionTypes.Dashboard.GET_STATS_DATA: {
      return {
        ...state,
        accounts: action.payload.data.account_count,
        users: action.payload.data.user_info.user_count,
        activeUsers: action.payload.data.user_info.active_user_count,
        objects: action.payload.data.data_info.object_count,
        publicObjects: action.payload.data.data_info.public_object_count,
        privileges: action.payload.data.privilege_info.privilege_count,
        usedPrivileges: action.payload.data.privilege_info.used_privilege_count,
        instances: action.payload.data.instance_info.instance_count,
        publicInstances:
          action.payload.data.instance_info.public_instance_count,
        networks: action.payload.data.network_info.network_count,
        publicNetworks: action.payload.data.network_info.public_network_count,
        unknownAccountCount:
          action.payload.data.shadow_access_info.account_count,
        unknownNetworkCount:
          action.payload.data.shadow_access_info.network_count,
        publicObjectsCounts: action.payload.publicObjectDict,
        unusedSensitivePrivs: action.payload.data.sensitive_privilege_info
      }
    }

    default: {
      return state
    }
  }
}
